import { Eye } from 'lucide-react';

const ViewIcon = () => (
	<div className="items-center bg-[rgb(239,244,252)] rounded-full border-0 cursor-pointer inline-flex h-[34px] justify-center transition-colors duration-300 w-[34px] active:bg-[rgb(177,202,243)] focus:bg-[rgb(177,202,243)] focus:outline-none hover:bg-[rgb(177,202,243)]">
		<Eye className="w-5 h-5 stroke-primary stroke-[1.5]" />
		<span className="sr-only">View Icon</span>
	</div>
);

export default ViewIcon;
